import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo_b.png'
import _imports_1 from '../../assets/images/footer/icon_facebook.png'
import _imports_2 from '../../assets/images/footer/icon_Linkedin.png'
import _imports_3 from '../../assets/images/footer/icon_blog.png'


const _withScopeId = n => (_pushScopeId("data-v-23bf9199"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "info-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Smart Process",
      width: "263",
      height: "35"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("株式会社 Smart Process"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 〒105 - 7508"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 東京都港区海岸1-7-1"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 東京ポートシティ竹芝8F")
  ])
], -1))
const _hoisted_4 = { class: "SNS-All" }
const _hoisted_5 = {
  class: "SNS-title",
  id: "SNS"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"SNS-box\" data-v-23bf9199><li data-v-23bf9199><a href=\"https://www.facebook.com/people/%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BESmart-Process/100087517794324/\" data-v-23bf9199><img src=\"" + _imports_1 + "\" alt=\"FACEBOOK\" width=\"45\" height=\"45\" data-v-23bf9199></a></li><li data-v-23bf9199><a href=\"https://www.linkedin.com/company/%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BEsmart-process/\" data-v-23bf9199><img src=\"" + _imports_2 + "\" alt=\"LINKEDIN\" width=\"45\" height=\"45\" data-v-23bf9199></a></li><li data-v-23bf9199><a href=\"http://blog.smart-process.co.jp/wp/\" data-v-23bf9199><img src=\"" + _imports_3 + "\" alt=\"BlOG\" width=\"45\" height=\"45\" data-v-23bf9199></a></li></div>", 1)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "© Smart Process Co.,Ltd.", -1))
const _hoisted_8 = {
  href: "#",
  class: "gotop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactButton = _resolveComponent("ContactButton")!
  const _component_SNS_txt = _resolveComponent("SNS-txt")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ContactButton, {
        class: "btn-contact",
        style: _normalizeStyle({ display: _ctx.display })
      }, null, 8, ["style"]),
      _createElementVNode("ul", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_SNS_txt, null, {
                  default: _withCtx(() => [
                    _createTextVNode("  Smart Process 公式SNSアカウント ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_6
            ])
          ])
        ])
      ])
    ]),
    _hoisted_7,
    _withDirectives(_createElementVNode("a", _hoisted_8, null, 512), [
      [_vShow, _ctx.visible1]
    ])
  ]))
}